export const SAMPLE_1 = `[00:28.78] Zindagi ne ki hai kaisi saazishein
[00:37.30] Poori hui dil ki wo farmaishein
[00:45.94] Maangi duaa ek tujh tak jaa pahunchi
[00:50.40] Parvardigara, parvardigara
[00:54.97] Kaisi suni tune meri khamoshi
[00:58.86] O parvardigara
[01:03.07] Ye fitoor mera laaya mujhko hai tere kareeb
[01:11.97] Ye fitoor mera rehmat teri
[01:20.43] Ye fitoor mera maine badla re mera naseeb
[01:29.50] Ye fitoor mera chaahat teri
[01:36.83] O parvardigara, parvardigara
[01:42.86] 
[02:00.90] Dheeme dheeme jal rahi thi khwaishein
[02:09.52] Dil mein dabi, ghut rahi farmaaishein
[02:18.13] Banke dhuaan wo
[02:20.54] Tujh tak jaa pahunchi, parvardigara.
[02:24.56] 
[02:26.94] Deewangi ki hadd maine nochi o parvardigara
[02:35.21] Ye fitoor mera laaya mujhko hai tere kareeb
[02:43.96] Ye fitoor mera rehmat teri
[02:52.88] Ye fitoor mera maine badla re mera naseeb
[02:01.66] Ye fitoor mera chahat teri
[03:09.29] O parvardigara, parvardigara
[03:16.14] 
[03:56.47] Ye fitoor mera laaya mujhko hai tere kareeb
[04:05.45] Ye fitoor mera rehmat teri
[04:14.18] Ye fitoor mera maine badla re mera naseeb
[04:23.04] Ye fitoor mera chahat teri
[04:31.32] Parvardigara...
[04:35.90] `;

const SP = String.fromCharCode(0x2005);

export const SAMPLE_2 = `[ar:Ved Sharma,Kunaal Vermaa]
[al:Malang (Title Track) [From "Malang - Unleash The Madness"]]
[ti:Malang (Title Track) [From "Malang - Unleash The Madness"]]
[length:04:47.37]

[00:12.84]Kaafira toh chal diya iss safar ke sang
[00:19.43]Kaafira toh chal diya iss safar ke sang
[00:25.42]Manzilein na dor${SP}koyi${SP}leke apna rang
[00:30.38]Rahun${SP}main malang malang malang
[00:33.38]Rahun main malang ${SP}malang malang
[00:36.36]Rahun main malang malang malang
[00:40.04]Main malang haye re
[00:43.70]
[00:56.18]Main bairagi sa jeeu ye bhatakta man
[01:02.31]Main bairagi sa jeeu ye bhatakta man
[01:08.45]Ab kahan le jayega ye awarapan
[01:13.33]Rahun main malang malang malang
[01:16.47]Rahun main malang malang malang
[01:19.65]Rahun main malang malang malang
[01:23.27]Main malang haye re
[01:26.95]
[01:51.48]Hai nasibon mein safar toh
[01:54.60]Main kahi bhi kyun rukun
[02:03.83]Hai nasibon mein safar toh
[02:06.95]Main kahi bhi kyun rukun
[02:10.05]Chodke aaya kinare
[02:13.02]Beh saku jitna bahun
[02:16.21]Din guzarte hi rahe
[02:19.19]Yun hi bemausam
[02:22.32]Raaste tham jaye par
[02:25.38]Ruk na paye hum
[02:27.24]
[02:27.31]Rahun main malang malang malang
[02:30.28]Rahun main malang malang malang
[02:33.58]Rahun main malang malang malang
[02:36.91]Main malang haye re
[02:39.37]
[03:21.02]Rubaru khud se huya hu
[03:23.73]Mujhe mein mujhko tu mila
[03:33.31]Rubaru khudse hua hu
[03:36.29]Mujhe mein mujhko tu mila
[03:39.38]Badalo ke iss jahan mein
[03:42.26]Aasmaan tujhme mila
[03:45.24]
[03:45.52]Pighli hai ab raat bhi
[03:48.54]Hai sehar bhi ye nam
[03:51.45]Naa Khuda main to raha
[03:54.52]Ban gaya tu dharam
[03:56.52]Rahun main malang malang malang
[03:59.57]Rahun main malang malang malang
[04:02.57]Rahun main malang malang malang
[04:06.29]Main malang haye re
[04:09.85]`;
